import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/index',
    name: 'Index',
    component: resolve => require(['@/pages/index/index'], resolve),
    hidden: true
  },
  {
    path: '/',
    hidden: true,
    redirect: '/index'
  },
  {
    path: '*',
    component: resolve => require(['@/components/404'], resolve),
    hidden: true
  },
  {
    path: '/spww',
    component: resolve => require(['@/pages/spww/index'], resolve),
    meta: {
      favicon: 'UBI_SPWW',
      title: 'SPWW'
    },
    hidden: true
  },
  {
    path: '/ubi',
    component: resolve => require(['@/pages/ubi/index'], resolve),
    meta: {
      favicon: 'UBI',
      title: 'UBI'
    },
    hidden: true
  },
  {
    path: '/home',
    component: resolve => require(['@/pages/etower/index'], resolve),
    meta: {
      favicon: 'eTower',
      title: 'eTower'
    },
    hidden: true
  },
  {
    path: '/login',
    name: 'Login',
    component: resolve => require(['@/pages/login/index'], resolve),
    hidden: true
  },
  {
    path: '/superadmin',
    name: 'Superadmin',
    component: resolve => require(['@/pages/login/index'], resolve),
    hidden: true
  }
]

/**
 * asyncRoutes
 */
const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
